import { render } from "./AdultsPage.vue?vue&type=template&id=5443ab72"
import script from "./AdultsPage.vue?vue&type=script&lang=js"
export * from "./AdultsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__